import { ButtonPrimary } from "components/Atoms/Button";
import React from "react";
import { routes } from "utilities/routing/generatedRoutes";
import { DetailSidePanel } from "../DetailSidePanel";
import { GroundSidePanelDetails } from "./GroundSidePanelDetails";
import { useOpenSidePanel } from "../SidePanel";

export interface GroundTransportSidePanelProps {
  groundTransportId: number
  trigger: JSX.Element
}

export const GroundTransportSidePanel = (props: GroundTransportSidePanelProps) => {
  return <DetailSidePanel
    apiCall={() => window.CoreApi.GroundTransport.GetSidePanelData(props.groundTransportId)}
    apiKey="groundTransport"
    entityId={props.groundTransportId}
    title={RESX.GroundTransport.resxGroundTransport}
    footerContent={<>
      <ButtonPrimary href={routes.groundTransport_Detail(props.groundTransportId).absolute} label={RESX.Buttons.DetailView} />
    </>}
    trigger={props.trigger}
  >
    {(data) => <GroundSidePanelDetails
      groundTransportSidePanelData={data}
    />}
  </DetailSidePanel>
};

export const useOpenGroundTransportSidePanel = () => {
  const openSidePanel = useOpenSidePanel();

  const openGroundTransportSidePanel = React.useCallback((groundTransportId: number) => {
    openSidePanel(<DetailSidePanel
      apiCall={() => window.CoreApi.GroundTransport.GetSidePanelData(groundTransportId)}
      apiKey="groundTransport"
      entityId={groundTransportId}
      title={RESX.GroundTransport.resxGroundTransport}
      footerContent={<>
        <ButtonPrimary href={routes.groundTransport_Detail(groundTransportId).absolute} label={RESX.Buttons.DetailView} />
      </>}
      skipSidePanelBase
    >
      {(data) => <GroundSidePanelDetails
        groundTransportSidePanelData={data}
      />}
    </DetailSidePanel>, `groundTransport-side-${groundTransportId}`);

  }, [openSidePanel]);

  return openGroundTransportSidePanel;
}